"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var markComponent = function markComponent(props) {
  var active = props.active,
      mark = props.mark; // tslint:disable:max-line-length

  var smiles = {
    1: 'M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-9.333 10.666V24h6.666v-2.667h-6.666zm12 0V24h6.666v-2.667h-6.666zm-12 6.667s2.14 6.667 9.333 6.667S33.333 28 33.333 28H14.667z',
    2: 'M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zM17.083 28l-2.291 1.333c1.843 3.183 5.27 5.334 9.208 5.334 3.938 0 7.365-2.151 9.208-5.334L30.917 28c-1.386 2.39-3.948 4-6.917 4s-5.531-1.61-6.917-4z',
    3: 'M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 1-.001 4 2 2 0 0 1 .001-4zM16 27h16v2.7H16V27z',
    4: 'M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm-6 8c-3.557 0-6.693 1.78-8.625 4.458l2.167 1.542c1.453-2.021 3.78-3.334 6.458-3.334 2.677 0 5.005 1.313 6.458 3.334l2.167-1.542c-1.932-2.677-5.068-4.458-8.625-4.458z',
    5: 'M24 8C15.177 8 8 15.177 8 24s7.177 16 16 16 16-7.177 16-16S32.823 8 24 8zm0 2.667c7.38 0 13.333 5.953 13.333 13.333S31.38 37.333 24 37.333A13.312 13.312 0 0 1 10.667 24c0-7.38 5.953-13.333 13.333-13.333zm-6 8a2 2 0 1 0 .001 4 2 2 0 0 0-.001-4zm12 0a2 2 0 1 1-.001 4 2 2 0 0 1 .001-4zM17 32s1.605-5 7-5 7 5 7 5H17z'
  }; // tslint:enable:max-line-length

  var style = {
    fill: '#7B7B7C'
  };

  if (active) {
    style.fill = '#1f3b80';
  }

  return react_1.default.createElement("svg", {
    width: '100%',
    height: '100%',
    viewBox: '0 0 48 48',
    style: style
  }, react_1.default.createElement("path", {
    d: smiles[mark]
  }));
};

exports.default = markComponent;